<div class="banner" *ngIf="instanceBannerUrl">
  <img [src]="instanceBannerUrl" alt="Instance banner">
</div>
